import React from "react";
import {aodIconType} from "./aodUiUtils";

export function AodIcon({type, ...props}) {

    if ( !(type in aodIconType)) return null;
    const Icon = aodIconType[type];

    return <Icon {...props}/>
}